// Global ABRA front-end config
window.ABRA = window.ABRA || {};

// Fallback/default ISO-3166-1 alpha-2 country
window.ABRA.defaultCountry = "CZ"; // zatím nepoužíváme

// Postal code patterns by ISO country code
// NOTE: Keep this list small and extend as needed.
window.ABRA.postCode =
{
    // Czech Republic: 12345 or 123 45
    "CZ": /^\d{3}\s?\d{2}$/,
    "00000CZ000": /^\d{3}\s?\d{2}$/, // AbraGen ID
    // Slovakia: 12345 or 123 45
    "SK": /^\d{3}\s?\d{2}$/,
    "00000SK000": /^\d{3}\s?\d{2}$/,
    // Germany: 5 digits
    //"DE": /^\d{5}$/,
    // Add more here:
    // "AT": /^\d{4}$/,
    // "PL": /^\d{2}-\d{3}$/
};